import React from "react";
// import FeaturedSlider from "./FeaturedSlider"; // Not currently used
import summaryApi from "../common/index";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import Context from "../context/index";
import addToCart from "../helpers/addToCart";
import { toast } from "react-hot-toast";

export default function Hero() {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [wishlistedItems, setWishlistedItems] = useState(new Set());

  const navigate = useNavigate();
  const context = useContext(Context);
  const fetchUserAddToCart = context?.fetchUserAddToCart;
  const fetchUserWishlistCount = context?.fetchUserWishlistCount;

  const handleShopClick = () => {
    navigate("/products");
  };

  const fetchAllProducts = async () => {
    try {
      setLoading(true);
      setError(null);

      const fetchData = await fetch(summaryApi.allProduct.url, {
        method: summaryApi.allProduct.method,
      });

      const dataResponse = await fetchData.json();
      if (dataResponse.success) {
        setAllProducts(dataResponse.data);
      } else {
        setError(dataResponse.message);
      }
    } catch (error) {
      setError("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  const fetchWishlist = async () => {
    try {
      const res = await fetch(summaryApi.getWishlistProducts.url, {
        method: summaryApi.getWishlistProducts.method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (data.success && data.data) {
        const wishlistIds = new Set(data.data.map((item) => item.productId || item._id));
        setWishlistedItems(wishlistIds);
      }
    } catch (err) {
      console.error("Failed to load wishlist");
    }
  };

  const handleWishlistToggle = async (productId) => {
    if (!productId) return;
    const isWishlisted = wishlistedItems.has(productId);

    try {
      if (isWishlisted) {
        const res = await fetch(summaryApi.removeWishlistProduct.url, {
          method: summaryApi.removeWishlistProduct.method,
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productId }),
        });
        const data = await res.json();
        if (data.success) {
          setWishlistedItems((prev) => {
            const newSet = new Set(prev);
            newSet.delete(productId);
            return newSet;
          });
          toast.success("Product removed from wishlist!");
          await fetchUserWishlistCount?.();
        }
      } else {
        const res = await fetch(summaryApi.addToWishlist.url, {
          method: summaryApi.addToWishlist.method,
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productId }),
        });
        const data = await res.json();
        if (data.success) {
          setWishlistedItems((prev) => new Set(prev).add(productId));
          toast.success("Product added to wishlist!");
          await fetchUserWishlistCount?.();
        }
      }
    } catch (err) {
      toast.error("Could not update wishlist.");
    }
  };

  const handleAddToCart = async (e, productId) => {
    try {
      const result = await addToCart(e, productId);
      if (result.success) {
        await fetchUserAddToCart?.();
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  useEffect(() => {
    fetchAllProducts();
    fetchWishlist();
  }, []);

  // Get most selling products (first 8 products)
  const mostSellingProducts = allProducts.slice(0, 8);

  return (
    <section className="overflow-hidden bg-white">
      {/* Hero Section - Split Layout */}
      <div className="bg-[#FAF3E0] py-6 md:py-8 lg:py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center">
            {/* Left Side - Text Content */}
            <div className="text-center lg:text-left space-y-4 md:space-y-5">
              <p className="text-[#8B4513] text-xs md:text-sm font-bold uppercase tracking-wider">
                REAL DATES, REAL HEALTH
              </p>
              <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-[#654321] leading-tight">
                Fresh Dates Big Discount
              </h1>
              <p className="text-sm md:text-base lg:text-lg text-[#8B4513] font-semibold">
                Save up to 50% Off on your first order
              </p>
              
              {/* Trust Badges */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 pt-2">
                <div className="flex items-center gap-2 text-xs md:text-sm text-[#654321]">
                  <svg className="w-4 h-4 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">100% Natural</span>
                </div>
                <div className="flex items-center gap-2 text-xs md:text-sm text-[#654321]">
                  <svg className="w-4 h-4 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">Free Delivery</span>
                </div>
                <div className="flex items-center gap-2 text-xs md:text-sm text-[#654321]">
                  <svg className="w-4 h-4 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">Premium Quality</span>
                </div>
              </div>

              <div className="pt-2">
                <button
                  onClick={handleShopClick}
                  className="bg-[#8B4513] text-white px-6 md:px-8 py-2.5 md:py-3 text-sm md:text-base font-bold hover:bg-[#654321] transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 rounded-lg inline-flex items-center gap-2"
                  disabled={loading}
                >
                  Order Now
                  <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>

              {/* Stats Section */}
              <div className="grid grid-cols-3 gap-4 pt-4 border-t border-[#D4AF37]/30">
                <div className="text-center lg:text-left">
                  <p className="text-lg md:text-xl font-bold text-[#8B4513]">500+</p>
                  <p className="text-xs md:text-sm text-[#654321]">Happy Customers</p>
                </div>
                <div className="text-center lg:text-left">
                  <p className="text-lg md:text-xl font-bold text-[#8B4513]">1000+</p>
                  <p className="text-xs md:text-sm text-[#654321]">Orders Delivered</p>
                </div>
                <div className="text-center lg:text-left">
                  <p className="text-lg md:text-xl font-bold text-[#8B4513]">4.9★</p>
                  <p className="text-xs md:text-sm text-[#654321]">Customer Rating</p>
                </div>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="relative order-first lg:order-last flex items-center justify-center h-full w-full">
              <div className="relative w-full flex justify-center">
                <img 
                  src="/hero/hero15.png" 
                  alt="Fresh Dates Collection" 
                  className="w-full max-w-[80%] sm:max-w-[70%] md:max-w-[60%] lg:max-w-[85%] xl:max-w-[75%] h-auto max-h-[400px] md:max-h-[450px] lg:max-h-[500px] object-contain mx-auto"
                  style={{ mixBlendMode: 'multiply' }}
                  onError={(e) => {
                    e.target.src = "/hero/hero2.png";
                  }}
                />
                {/* Decorative Elements */}
                <div className="absolute -top-4 -right-4 w-20 h-20 bg-[#D4AF37]/20 rounded-full blur-xl hidden lg:block"></div>
                <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-[#8B4513]/20 rounded-full blur-xl hidden lg:block"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Highlights Section - Redesigned */}
      <div className="bg-gradient-to-br from-[#8B4513] to-[#654321] py-10 md:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <svg className="w-6 h-6 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </div>
                <h3 className="text-white text-lg md:text-xl font-bold">Premium Quality</h3>
              </div>
              <p className="text-white/90 text-sm leading-relaxed">
                Handpicked dates from Madinah Al Munawwarah, ensuring the finest quality and freshness in every order.
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <svg className="w-6 h-6 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                  </svg>
                </div>
                <h3 className="text-white text-lg md:text-xl font-bold">Easy Ordering</h3>
              </div>
              <p className="text-white/90 text-sm leading-relaxed">
                Simple checkout process with secure payment options. Order in just a few clicks and get your dates delivered.
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <svg className="w-6 h-6 text-[#8B4513]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                    <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
                  </svg>
                </div>
                <h3 className="text-white text-lg md:text-xl font-bold">Fast Delivery</h3>
              </div>
              <p className="text-white/90 text-sm leading-relaxed">
                Quick and reliable delivery service. We ensure your premium dates reach you fresh and on time.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products Preview Section - Enhanced */}
      {!loading && mostSellingProducts.length > 0 && (
        <div className="bg-gradient-to-b from-[#FAF3E0]/50 to-white py-10 md:py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-[#654321] mb-3">
                Featured Products
              </h2>
              <p className="text-gray-600 text-sm md:text-base max-w-xl mx-auto">
                Discover our handpicked selection of premium dates, carefully selected for their exceptional quality
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
              {mostSellingProducts.slice(0, 4).map((product) => (
                <div key={product._id} className="transform transition-all duration-300 hover:-translate-y-2">
                  <ProductCard
                    product={product}
                    isWishlisted={wishlistedItems.has(product._id)}
                    onWishlistToggle={handleWishlistToggle}
                    onAddToCart={(id) => handleAddToCart(null, id)}
                  />
                </div>
              ))}
            </div>
            <div className="text-center mt-8 md:mt-10">
              <button
                onClick={handleShopClick}
                className="bg-[#8B4513] text-white px-8 py-3 text-sm md:text-base font-bold hover:bg-[#654321] transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 inline-flex items-center gap-2"
              >
                Explore All Products
                <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Most Selling Products Section - Enhanced */}
      <div className="bg-gradient-to-b from-white to-[#FAF3E0]/30 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#654321] mb-3">
              Most Selling Products
            </h2>
            <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
              Discover our bestsellers - premium dates loved by thousands of customers
            </p>
            <div className="flex items-center justify-center gap-2 mt-4">
              <div className="h-1 w-12 bg-[#8B4513] rounded-full"></div>
              <div className="h-1 w-8 bg-[#D4AF37] rounded-full"></div>
              <div className="h-1 w-12 bg-[#8B4513] rounded-full"></div>
            </div>
          </div>
          
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B4513]"></div>
                <p className="mt-4 text-[#654321] font-medium">Loading products...</p>
              </div>
            </div>
          ) : mostSellingProducts.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
              {mostSellingProducts.map((product) => (
                <div key={product._id} className="transform transition-all duration-300 hover:-translate-y-2">
                  <ProductCard
                    product={product}
                    isWishlisted={wishlistedItems.has(product._id)}
                    onWishlistToggle={handleWishlistToggle}
                    onAddToCart={(id) => handleAddToCart(null, id)}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-600">No products available at the moment.</p>
            </div>
          )}

          {!loading && mostSellingProducts.length > 0 && (
            <div className="text-center mt-10 md:mt-12">
              <button
                onClick={handleShopClick}
                className="bg-[#8B4513] text-white px-8 md:px-10 py-3 md:py-3.5 text-sm md:text-base font-bold hover:bg-[#654321] transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 inline-flex items-center gap-2"
              >
                View All Products
                <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>

      {error && (
        <div className="text-center py-8">
          <p className="text-red-600">Error loading products: {error}</p>
          <button
            onClick={fetchAllProducts}
            className="mt-4 bg-black text-white px-6 py-2 hover:bg-gray-800 transition"
          >
            Retry
          </button>
        </div>
      )}

      {/* Slider Section */}
      {/* <FeaturedSlider /> */}
    </section>
  );
}
